import { render } from "./pc-popup.vue?vue&type=template&id=4dbd769d&scoped=true&ts=true"
import script from "./pc-popup.vue?vue&type=script&lang=ts"
export * from "./pc-popup.vue?vue&type=script&lang=ts"

import "./pc-popup.vue?vue&type=style&index=0&id=4dbd769d&scoped=true&lang=scss"

import exportComponent from "/Users/panren/Desktop/太平洋网络/discount-topics-wap-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbd769d"]])

export default __exports__